// extracted by mini-css-extract-plugin
module.exports = {"mask":"spinner_mask__IqCUw","logo":"spinner_logo__azkQg"};